export function xmlToObj(xmlString): any {
  const parsed = {};
  const parts = xmlString.split(';');

  parts.forEach(function (item) {
    if (item !== '') {
      const pair = item.split('=');

      parsed[pair[0]] = pair[1];
    }
  });

  return parsed;
}
